<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card>
          <va-tabs v-model="tabIndex">
            <va-tab>Gestion des documents</va-tab>
            <va-tab>Gestion des annonces types</va-tab>
          </va-tabs>
          <div class="flex md12 mt-4" v-if="tabIndex === 1">
            <div class="row row-inside separated titles">
              <div class="flex md2">
                <h4>Nom</h4>
              </div>
              <div class="flex md2">
                <h4>Montant HT</h4>
              </div>
              <div class="flex md2">
                <h4>Remise</h4>
              </div>
              <div class="flex md2">
                <h4>Type</h4>
              </div>
              <div class="flex md2">
                <h4>Taille</h4>
              </div>
              <div class="flex md2">
                <h4>Actions</h4>
              </div>
            </div>
            <div
              v-for="template in listTemplate"
              class="row row-inside separated"
            >
              <div class="flex md2">
                <h4 class="centered-template">{{ template.nom }}</h4>
              </div>
              <div class="flex md2">
                <h4 class="centered-template">{{ template.montant }} €</h4>
              </div>
              <div class="flex md2">
                <h4 class="centered-template">
                  {{ template.remise ? template.remise + " €" : "-" }}
                </h4>
              </div>
              <div class="flex md2">
                <h4 class="centered-template">{{ template.type }}</h4>
              </div>
              <div class="flex md2">
                <h4 class="centered-template">
                  {{
                    template.type === "presse" ? template.size + " page" : "-"
                  }}
                </h4>
              </div>
              <div class="flex md2">
                <va-popover message="Modifier">
                  <va-button
                    large
                    flat
                    icon="fa fa-edit"
                    color="info"
                    @click=""
                  />
                </va-popover>
              </div>
            </div>
          </div>
          <div class="flex md12 mt-4" v-if="tabIndex === 0">
            <div class="row row-inside separated">
              <div class="flex md2">
                <h4 class="centered-title">Modèle kit média</h4>
              </div>
              <div class="flex md1">
                <va-popover message="Ouvrir le document">
                  <va-button
                    large
                    outline
                    icon="fa fa-eye"
                    color="info"
                    @click=""
                  />
                </va-popover>
              </div>
              <div class="flex md1">
                <va-popover message="Modifier le document">
                  <va-button
                    large
                    icon="fa fa-plus"
                    color="success"
                    @click=""
                  />
                </va-popover>
              </div>
            </div>
            <div class="row row-inside separated">
              <div class="flex md2">
                <h4 class="centered-title">Modèle devis simple</h4>
              </div>
              <div class="flex md1">
                <va-popover message="Ouvrir le document">
                  <va-button
                    large
                    outline
                    icon="fa fa-eye"
                    color="info"
                    @click=""
                  />
                </va-popover>
              </div>
              <div class="flex md1">
                <va-popover message="Modifier le document">
                  <va-button
                    large
                    icon="fa fa-plus"
                    color="success"
                    @click=""
                  />
                </va-popover>
              </div>
            </div>
            <div class="row row-inside separated">
              <div class="flex md2">
                <h4 class="centered-title">Modèle devis remisé</h4>
              </div>
              <div class="flex md1">
                <va-popover message="Ouvrir le document">
                  <va-button
                    large
                    outline
                    icon="fa fa-eye"
                    color="info"
                    @click=""
                  />
                </va-popover>
              </div>
              <div class="flex md1">
                <va-popover message="Modifier le document">
                  <va-button
                    large
                    icon="fa fa-plus"
                    color="success"
                    @click=""
                  />
                </va-popover>
              </div>
            </div>
            <div class="row row-inside separated">
              <div class="flex md2">
                <h4 class="centered-title">Facture simple</h4>
              </div>
              <div class="flex md1">
                <va-popover message="Ouvrir le document">
                  <va-button
                    large
                    outline
                    icon="fa fa-eye"
                    color="info"
                    @click=""
                  />
                </va-popover>
              </div>
              <div class="flex md1">
                <va-popover message="Modifier le document">
                  <va-button
                    large
                    icon="fa fa-plus"
                    color="success"
                    @click=""
                  />
                </va-popover>
              </div>
            </div>
            <div class="row row-inside separated">
              <div class="flex md2">
                <h4 class="centered-title">Facture hors UE</h4>
              </div>
              <div class="flex md1">
                <va-popover message="Ouvrir le document">
                  <va-button
                    large
                    outline
                    icon="fa fa-eye"
                    color="info"
                    @click=""
                  />
                </va-popover>
              </div>
              <div class="flex md1">
                <va-popover message="Modifier le document">
                  <va-button
                    large
                    icon="fa fa-plus"
                    color="success"
                    @click=""
                  />
                </va-popover>
              </div>
            </div>
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "configuration-annonces",
  data() {
    return {
      tabIndex: 0,
      listTemplate: [],
    };
  },
  created() {
    this.loadListAnnonces();
  },
  methods: {
    async loadListAnnonces() {
      try {
        let resTmp = await axios.get("/api/publications/templateList");
        this.listTemplate = resTmp.data;
      } catch (error) {
        //todo message to user
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.centered-title {
  position: relative;
  top: 1em;
}

.separated {
  border-bottom: solid 1px #ccc;
}

.titles {
  color: rgb(143, 143, 143);
}

.centered-template {
  position: relative;
  top: 1em;
}
</style>
